module.exports = " <div class=content> <div class=\"container home padding-top\"> <menu-home> <div slot=title>Seleccione</div> <div slot=buttons aria-label=\"Justified button group\" role=group class=\"btn-group btn-group-justified\"> <menu-button menu-url=home/championships glyph-icon=glyphicon-list-alt>Lista de Campeonatos</menu-button> <menu-button menu-url=configuration glyph-icon=glyphicon-cog>Preferencias</menu-button> </div> </menu-home> </div> <router-view></router-view> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** /home/onlygamescl/onlygames-front/shared/~/vue-html-loader!/home/onlygamescl/onlygames-front/shared/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
 ** module id = 286
 ** module chunks = 1
 **/